<template>
  <div class="main" style="padding-top: 0px;margin-top: 0px">
    <div class="ar-contain" style="background: white">
      <div class="ar-title">注册用户</div>
      <form id="userForm">
        <div class="ar-list">
          <div class="ar-items">
            <label><span class="icon_red">*</span>用户名</label>
            <input type="text" v-model="userInfo.userName" id="userName" name="userName">
            <el-tag type="danger" v-if="userNameMsg != null">{{ userNameMsg }}</el-tag>
          </div>
          <div class="ar-items">
            <label><span class="icon_red">*</span>密码</label>
            <input type="password" v-model="userInfo.password" id="password" name="password">
            <el-tag type="danger" v-if="passwordMsg != null">{{ passwordMsg }}</el-tag>
          </div>
          <div class="ar-items">
            <label><span class="icon_red">*</span>确认密码</label>
            <input type="password" id="repeatPwd" v-model="userInfo.repeatPwd" name="repeatPwd">
            <el-tag type="danger" v-if="repeatPwdMsg != null">{{ repeatPwdMsg }}</el-tag>
          </div>
          <div class="ar-items ar-radio">
            <label><span class="icon_red">*</span>用户类型</label>
            <i style="font-style: normal;cursor: pointer" class="ar-radio-i"><input v-model="userInfo.userType"
                                                                                    type="radio" name="userType"
                                                                                    checked="checked"
                                                                                    value="2"><b>企业</b></i>
            <i style="font-style: normal;cursor: pointer" class="ar-radio-i"><input v-model="userInfo.userType"
                                                                                    type="radio" name="userType"
                                                                                    value="1"><b>个人</b></i>
          </div>
          <div class="ar-items ar-company" v-show="parseInt(userInfo.userType) === 2">
            <label><span class="icon_red">*</span>企业注册号</label>
            <input type="text" id="companyNumber" v-model="userInfo.companyNumber" name="companyNumber">
            <el-tag type="danger" v-if="companyNumberMsg != null">{{ companyNumberMsg }}</el-tag>
          </div>
          <div class="ar-items ar-company" v-if="parseInt(userInfo.userType) === 2">
            <label><span class="icon_red">*</span>法人姓名</label>
            <input type="text" id="legalPerson" v-model="userInfo.legalPerson" name="legalPerson">
            <el-tag type="danger" v-if="legalPersonMsg != null">{{ legalPersonMsg }}</el-tag>
          </div>
          <div class="ar-items ar-company" v-if="parseInt(userInfo.userType) === 2">
            <label><span class="icon_red">*</span>法人身份证</label>
            <input type="text" id="legalIdNumber" v-model="userInfo.legalIdNumber" name="legalIdNumber">
            <el-tag type="danger" v-if="legalIdNumberMsg != null">{{ legalIdNumberMsg }}</el-tag>
          </div>
          <div class="ar-items">
            <label><span class="icon_red">*</span>申请人</label>
            <input type="text" id="applyName" v-model="userInfo.applyName" name="applyName"/>
            <el-tag type="danger" v-if="applyNameMsg != null">{{ applyNameMsg }}</el-tag>
          </div>
          <div class="ar-items">
            <label><span class="icon_red">*</span>申请人身份证</label>
            <input type="text" id="applyIdNumber" v-model="userInfo.applyIdNumber" name="applyIdNumber">
            <el-tag type="danger" v-if="applyIdNumberMsg != null">{{ applyIdNumberMsg }}</el-tag>
          </div>
          <div class="ar-items">
            <label><span class="icon_red">*</span>手机号码</label>
            <input type="text" id="mobile" v-model="userInfo.mobile" name="mobile">
            <el-tag type="danger" v-if="mobileMsg != null">{{ mobileMsg }}</el-tag>
          </div>
          <div class="ar-items">
            <label><span class="icon_red">*</span>邮箱</label>
            <input type="text" id="email" v-model="userInfo.email" name="email">
            <el-tag type="danger" v-if="emailMsg != null">{{ emailMsg }}</el-tag>
          </div>
          <div class="ar-items" style="position:relative;">
            <label><span class="icon_red">*</span>验证码</label>
            <input type="text" placeholder="请输入验证码" id="verCode" v-model="userInfo.verCode" name="verCode">
            <img id="kaptcha" @click="kaptchaClick" :src="kaptchaUrl"
                 style="width:100px; height:36px; position: absolute; left:404px; top:1px; border:1px solid #d2d6de;cursor:pointer;"
                 alt="验证码"/>
            <el-tag type="danger" v-if="verCodeMsg != null">{{ verCodeMsg }}</el-tag>
          </div>
        </div>
        <div class="ar-submit">
          <div class="ar-btn" id="submitForm" @click="submitForm">注册</div>
          <p class="ar-info">已有账号！去
            <router-link :to="{path:'/index'}">登录</router-link>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'
import { encryption } from '../assets/js/utils'
export default {
  name: 'register',
  components: {
    'navigation': navigation
  },
  data: function () {
    return {
      kaptchaUrl: this.config.kaptchaUrl,
      rules: {
        userName: [
          {required: true, message: '请填写用户名', trigger: ['blur', 'change']}
        ], password: [
          {required: true, message: '请输入6-16位数字、字母、下划线的组合', trigger: ['blur', 'change']}
        ], repeatPwd: [
          {required: true, message: '与已输入密码保持一致', trigger: ['blur', 'change']}
        ], userType: [
          {required: true, message: '请选择用户类型', trigger: ['blur', 'change']}
        ]
      },
      msg: [
        {infoMsg: false, errorMsg: '用户名至少1个字符,最多12个字符！'},
        {infoMsg: false, errorMsg: '密码范围在6~16位之间！'},
        {infoMsg: false, errorMsg: '您两次输入的账号密码不一致！'},
        {infoMsg: false, errorMsg: '昵称至少1个字符,最多12个字符！'},
        {infoMsg: false, errorMsg: '身份证只能18位！'},
        {infoMsg: false, errorMsg: '请填写正确的手机号码！'},
        {infoMsg: false, errorMsg: '请填写正确的邮箱！'},
        {infoMsg: false, errorMsg: '验证码错误！'},
        {infoMsg: false, errorMsg: '请输入2-20位数字、字母、下划线的组合！'},
        {infoMsg: false, errorMsg: '请填写正确身份证(括号必须用英文的)！'}
      ],
      userNameMsg: null,
      passwordMsg: null,
      companyNumberMsg: null,
      repeatPwdMsg: null,
      legalPersonMsg: null,
      legalIdNumberMsg: null,
      applyNameMsg: null,
      applyIdNumberMsg: null,
      mobileMsg: null,
      emailMsg: null,
      verCodeMsg: null,
      userInfo: {
        legalPerson: null,
        applyIdNumber: null,
        applyName: null,
        mobile: null,
        verCode: null,
        email: null,
        legalIdNumber: null,
        userName: null,
        userType: '2',
        password: null,
        companyNumber: null,
        repeatPwd: null
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.kaptchaClick()
    });
  }, methods: {
    kaptchaClick() {
      var img = document.getElementById("kaptcha");
      img.setAttribute("src", this.kaptchaUrl);
    },
    /**
     *  提交注册申请
     */
    submitForm(_self) {
      // 测试提交
      if (!this.checkInput()) {
        return
      }
      _self = this
      const userData = {
        legalPerson: this.userInfo.legalPerson,
        applyIdNumber: this.userInfo.applyIdNumber,
        applyName: this.userInfo.applyName,
        mobile: this.userInfo.mobile,
        verCode: this.userInfo.verCode,
        email: this.userInfo.email,
        legalIdNumber: this.userInfo.legalIdNumber,
        userName: this.userInfo.userName,
        userType: this.userInfo.userType,
        companyNumber: this.userInfo.companyNumber,
        password: encryption(this.userInfo.password, _self.api.aesKey),
        repeatPwd: encryption(this.userInfo.repeatPwd, _self.api.aesKey)
      }
      _self.axios.post(
        _self.api.register, userData,
      ).then(results => {
        if (results.data.code !== 10000) {
          this.$message.error(results.data.message)
          this.kaptchaClick()
        } else {
          this.$message.success(results.data.message)
          this.$router.push({
            path: '/index'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * 检查表单
     */
    checkInput() {
      let flag = true
      if (this.userInfo.userName == null) {
        this.userNameMsg = '请填写用户名!'
        flag = false
      } else if (this.userInfo.userName != null && this.userInfo.userName.length < 2) {
        this.userNameMsg = '用户名至少1个字符,最多12个字符！'
        flag = false
      } else {
        this.userNameMsg = null
      }
      if (this.userInfo.password == null) {
        this.passwordMsg = '请设置密码!'
        flag = false
      } else if (this.userInfo.password != null && (this.userInfo.password.length < 8 || this.userInfo.password.length > 16)) {
        this.passwordMsg = '密码范围在8~16位之间！'
        flag = false
      } else {
        let modes = 0
        if (/\d/.test(this.userInfo.password)) modes++; //数字
        if (/[a-z]/.test(this.userInfo.password)) modes++; //小写
        if (/[A-Z]/.test(this.userInfo.password)) modes++; //大写
        if (modes < 3) {
          this.passwordMsg = '密码必须包含数字、大小写英文字母！例如:Qzhang888'
          flag = false
        } else {
          this.passwordMsg = null
        }
      }
      if (this.userInfo.repeatPwd == null) {
        this.repeatPwdMsg = '请输入确认密码'
        flag = false
      } else if (this.userInfo.repeatPwd !== this.userInfo.password) {
        this.repeatPwdMsg = '您两次输入的账号密码不一致！'
        flag = false
      } else {
        this.repeatPwdMsg = null
      }
      if (this.userInfo.userType == 2) {
        if (this.userInfo.companyNumber == null) {
          this.companyNumberMsg = '请填写企业注册号!'
          flag = false
        } else if (this.userInfo.companyNumber != null && (this.userInfo.companyNumber.length < 2 || this.userInfo.companyNumber.length > 20)) {
          this.companyNumberMsg = '请输入2-20位数字、字母、下划线的组合!'
          flag = false
        } else {
          this.companyNumberMsg = null
        }
      } else {
        this.companyNumberMsg = null
      }
      if (this.userInfo.userType == 2) {
        if (this.userInfo.legalPerson == null) {
          this.legalPersonMsg = '法定代表人姓名!'
          flag = false
        } else if (this.userInfo.legalPerson != null && (this.userInfo.legalPerson.length < 2 || this.userInfo.legalPerson.length > 12)) {
          this.legalPersonMsg = '法定代表人姓名至少2个字符,最多12个字符!'
          flag = false
        } else {
          this.legalPersonMsg = null
        }
      } else {
        this.legalPersonMsg = null
      }
      if (this.userInfo.userType == 2) {
        if (this.userInfo.legalIdNumber == null || this.userInfo.legalIdNumber.length !== 18) {
          this.legalIdNumberMsg = '身份证号有误!'
          flag = false
        } else {
          this.legalIdNumberMsg = null
        }
      } else {
        this.legalIdNumberMsg = null
      }

      if (this.userInfo.applyName == null || this.userInfo.applyName === '') {
        this.applyNameMsg = '请输入申请人（或代理人）名称!'
        flag = false
      } else {
        this.applyNameMsg = null
      }
      if (this.userInfo.applyIdNumber == null || this.userInfo.applyIdNumber === '' || this.userInfo.applyIdNumber.length !== 18) {
        this.applyIdNumberMsg = '身份证号有误!'
        flag = false
      } else {
        this.applyIdNumberMsg = null
      }
      if (this.userInfo.mobile == null || this.userInfo.mobile === '' || this.userInfo.mobile.length !== 11) {
        this.mobileMsg = '请输入正确的手机号码!'
        flag = false
      } else {
        this.mobileMsg = null
      }
      if (this.userInfo.email == null || this.userInfo.email === '') {
        this.emailMsg = '请输入正确的邮箱地址!'
        flag = false
      } else {
        this.emailMsg = null
      }
      if (this.userInfo.verCode == null || this.userInfo.verCode === '') {
        this.verCodeMsg = '请输入验证码!'
        flag = false
      } else {
        this.verCodeMsg = null
      }
      return flag
    }
  }
}
</script>

<style>
@import '../assets/css/newStyle.css';
</style>



// WEBPACK FOOTER //
// src/components/register.vue